import { useMutation, useQuery } from '@tanstack/react-query';
import { QUERY_KEYS } from '../../config/constants';
import { addStandingOrdersFn, getOrdersFn } from '../../transactions/orders/orders';

const { ORDERS } = QUERY_KEYS;

const useOrders = (fetchCars = true) => {
  return useQuery([ORDERS], getOrdersFn, {
    staleTime: 5 * 60 * 1000,
    refetchOnWindowFocus: false,
    enabled: !!fetchCars,
  });
};

export const useAddStandingOrdersFn = () => {
  return useMutation({
    mutationFn: (payload) => addStandingOrdersFn(payload)
  })
}

export default useOrders;
